// The burst numeral on a portrait, drawn as SVG so it scales with its badge. The badge is sized as a
// share of the portrait's width with a plain percentage, and a font-size cannot follow that without a
// container query - which is what made portrait-heavy pages freeze (see nikke-icons.css).
export function NikkeBurstGlyph({ text = '' }) {
  return (
    <svg className="nikke-burst-glyph" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
      <text x="50" y="50">{text}</text>
    </svg>
  );
}
